import cloneDeep from 'lodash/cloneDeep'

// T is the type of the IDs inside the array (number or string)
// K is the type of the key used for the list name (string or number)
type GroupedIds<T extends string | number, K extends string | number> = {
  [key in K]: Array<T>
}

const toggleArrayItem = <T>(array: Array<T>, value: T): Array<T> => {
  const updatedArray = [...array]

  const index = updatedArray.findIndex(item => item === value)

  if (index !== -1){
    updatedArray.splice(index, 1)
  } else {
    updatedArray.push(value)
  }

  return updatedArray
}

function toggleGroupedIdsItem<T extends string | number, K extends string>(
  id: T,
  groupedIds: GroupedIds<T, K>,
  listName: K,
): GroupedIds<T, K> {
  const list: Array<T> = groupedIds[listName]

  const updatedGroupedIds: GroupedIds<T, K> = cloneDeep(groupedIds)

  const updatedList: Array<T> = toggleArrayItem(list, id)

  updatedGroupedIds[listName] = updatedList

  return updatedGroupedIds
}

export default toggleGroupedIdsItem
